<div class="blog__slider swiper-container">
  <div class="swiper-wrapper">
    <div *ngFor="let blog of blogData" class="swiper-slide">
      <app-blog-item [blog]="blog"></app-blog-item>
    </div>
  </div>
</div>
